"use client";

import {BusinessIdInput} from "@/components/common/BusinessIdInput";
import Select from "@/components/library/Select";
import {TwilioBusinessType} from "@/enums/twilio";
import {useTranslation} from "react-i18next";
import {BusinessIdType} from "@/utils/verification/businessId";

interface CompanyInfoTwilioFieldsProps {
   readonly businessIdType: BusinessIdType;
   readonly businessId: string;
   readonly twilioBusinessType: TwilioBusinessType | "";
   readonly hasSubmitted: boolean;
   readonly businessIdError: boolean;
   readonly twilioBusinessTypeError: boolean;
   readonly businessIdHelperText?: string;
   readonly onChange: (patch: {
      businessIdType?: BusinessIdType;
      businessId?: string;
      twilioBusinessType?: TwilioBusinessType | "";
   }) => void;
}

export function CompanyInfoTwilioFields({
   businessIdType,
   businessId,
   twilioBusinessType,
   hasSubmitted,
   businessIdError,
   twilioBusinessTypeError,
   businessIdHelperText,
   onChange,
}: CompanyInfoTwilioFieldsProps) {
   const {t} = useTranslation("onboarding");
   const {t: ts} = useTranslation("settings");

   return (
      <>
         <Select
            label={t("companyInfo.businessType")}
            placeHolder={t("companyInfo.businessType")}
            required
            options={Object.values(TwilioBusinessType).map((type) => ({
               label: ts(type),
               value: type,
            }))}
            value={twilioBusinessType || undefined}
            onChange={(e: {target: {value: string}}) => {
               onChange({twilioBusinessType: e.target.value as TwilioBusinessType});
            }}
            error={hasSubmitted && twilioBusinessTypeError}
            helperText={
               hasSubmitted && twilioBusinessTypeError ? t("validation.required") : undefined
            }
         />
         <Select
            label={t("companyInfo.businessIdType")}
            placeHolder={t("companyInfo.businessIdType")}
            required
            options={[
               {label: ts("ein"), value: "EIN"},
               {label: ts("cbn"), value: "CBN"},
            ]}
            value={businessIdType}
            onChange={(e: {target: {value: string}}) => {
               onChange({
                  businessIdType: e.target.value as BusinessIdType,
                  businessId: "",
               });
            }}
         />
         <BusinessIdInput
            type={businessIdType}
            label={ts(businessIdType === "CBN" ? "cbn" : "ein")}
            placeholder={ts(businessIdType === "CBN" ? "cbn" : "ein")}
            required
            value={businessId}
            helperText={businessIdHelperText}
            error={hasSubmitted && businessIdError}
            onValueChange={(next) => onChange({businessId: next})}
         />
      </>
   );
}
